/**
 * Shared formatting utilities used across multiple pages.
 */

/**
 * Format an ISO date string to "15 Jan 2026" format.
 */
export function formatDate(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

/**
 * Format a number as Indian Rupee currency (e.g. "₹12,34,567").
 */
export function formatCurrency(value) {
  if (value == null) return '—';
  return '₹' + Number(value).toLocaleString('en-IN');
}

/**
 * Format a number in Indian compact notation (K, L, Cr).
 * @param {number} value
 * @param {string} [prefix=''] - e.g. '₹'
 * @returns {string}
 */
export function formatIndianCompact(value, prefix = '') {
  if (value == null || isNaN(value)) return '—';
  const abs = Math.abs(value);
  let formatted;
  if (abs >= 1_00_00_000) {
    formatted = (value / 1_00_00_000).toFixed(2).replace(/\.?0+$/, '') + ' Cr';
  } else if (abs >= 1_00_000) {
    formatted = (value / 1_00_000).toFixed(2).replace(/\.?0+$/, '') + ' L';
  } else if (abs >= 1_000) {
    formatted = (value / 1_000).toFixed(1).replace(/\.0$/, '') + ' K';
  } else {
    formatted = String(Math.round(value));
  }
  return prefix + formatted;
}

/**
 * Format an ISO date string to a relative time ("5m ago", "2h ago", "3d ago").
 */
export function timeAgo(isoString) {
  if (!isoString) return '';
  const diff = (Date.now() - new Date(isoString)) / 1000;
  if (diff < 60) return 'just now';
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
}
